import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Home from '../containers/Home';
import SearchForm from './SearchForm';
import isLoggedIn from '../utils/index.js';

export default class Footer extends Component {
  render() {
    const { user } = this.props.auth;

    let fbUrl = 'https://m.facebook.com/WorldWideWomenco/';
    let linkedinUrl = 'https://m.linkedin.com/company/6643521?trk=tyah&trkInfo=clickedVertical%3Acompany%2CentityType%3AentityHistoryName%2CclickedEntityId%3Acompany_6643521%2Cidx%3A0';
    let twitterUrl = 'https://m.twitter.com/worldwidewomen4';

    if (this.props.browser.greaterThan.desktop) {
        fbUrl = 'https://facebook.com/WorldWideWomenco/';
        linkedinUrl = 'https://linkedin.com/company/6643521?trk=tyah&trkInfo=clickedVertical%3Acompany%2CentityType%3AentityHistoryName%2CclickedEntityId%3Acompany_6643521%2Cidx%3A0';
        twitterUrl = 'https://twitter.com/worldwidewomen4';
    }



    return (
      <div className="footer-inner">
        <Link to="/" className="footer-wordmark">WorldWideWomen</Link>

        <div className="footer-linksContainer">
          <ul className="footer-links">
            <li><Link className="footer-link" to="/what-we-do">What We Do</Link></li>
            <li><Link className="footer-link" to="/pages/meet-the-team">Meet the Team</Link></li>
            <li><Link className="footer-link" to="/pages/contact">Contact</Link></li>

            <li><a target="_blank" className="footer-link" href="http://www.worldwidewomenfoundation.org/">WorldWideWomen Foundation</a></li>

            <li><Link className="footer-link" to="/pages/privacy-policy">Privacy Policy</Link></li>
            <li><Link className="footer-link" to="/pages/terms-conditions">Terms & Conditions</Link></li>
          </ul>

          <ul className="footer-cta-links">
            <li><a target="_blank" rel="noopener" className="footer-cta-link" href={twitterUrl}><img src="/images/footer/icon_twitter.png" /></a></li>

            <li><a target="_blank" rel="noopener" className="footer-cta-link" href={fbUrl}><img src="/images/footer/icon_fb.png" /></a></li>

            <li><a target="_blank" rel="noopener" className="footer-cta-link" href={'https://www.instagram.com/worldwidewomenco'}><img src="/images/footer/icon_instagram.png" /></a></li>

            
          </ul>
          <ul className="footer-cta-links">
            <li><a target="_blank" rel="noopener" className="footer-cta-link" href={linkedinUrl}><img src="/images/footer/icon_linkedin.png" /></a></li>

            <li><a target="_blank" rel="noopener" className="footer-cta-link" href={'http://www.youtube.com/c/Worldwidewomenco'}><img src="/images/footer/icon_youtube.png" /></a></li>
          </ul>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/Footer.jsx